import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  request: redukers.request({
    start: actionTypes.FETCH,
    success: actionTypes.SUCCESS,
    error: actionTypes.ERROR,
  }),
  data: redukers.entities({
    update: actionTypes.SET_DATA,
    reset: actionTypes.CLEAR_DATA,
    mergeById: actionTypes.UPDATE_DATA,
  }),
  count: redukers.value({
    set: actionTypes.SET_COUNT,
    reset: actionTypes.CLEAR_COUNT,
  }),
  removeAll: redukers.request({
    start: actionTypes.REMOVE_ALL,
    success: actionTypes.REMOVE_ALL_SUCCESS,
    error: actionTypes.REMOVE_ALL_ERROR,
  }),
  remove: redukers.request({
    start: actionTypes.REMOVE,
    success: actionTypes.REMOVE_SUCCESS,
    error: actionTypes.REMOVE_ERROR,
  }),
  readAll: redukers.request({
    start: actionTypes.READ_ALL,
    success: actionTypes.READ_ALL_SUCCESS,
    error: actionTypes.READ_ALL_ERROR,
  }),
  mark: redukers.request({
    start: actionTypes.MARK,
    success: actionTypes.MARK_SUCCESS,
    error: actionTypes.MARK_ERROR,
  }),
})
